import React from 'react';
export function Hero() {
  return <section className="relative h-[600px] w-full" data-id="element-102">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/xf67p1YsXTbZeaznZLBhbQ/560506698_1265434635613803_1777687380295572303_n.jpg')"
    }} data-id="element-103">
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-104"></div>
      </div>
      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-center items-center text-center" data-id="element-105">
        <h1 className="text-4xl md:text-5xl lg:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-106">
          Your Local Waste Service,
          <br data-id="element-107" />
          Proudly Serving the Community Since 1989.
        </h1>
        <p className="text-xl md:text-2xl text-white mb-8 font-semibold" data-id="element-108">
          Proudly serving Mecosta, Osceola, and Newaygo Counties.
        </p>
        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4" data-id="element-109">
          <a href="https://www.trashbilling.com/" target="_blank" rel="noopener noreferrer" className="bg-[#E41C1C] text-white font-bold px-8 py-4 rounded hover:bg-red-700 transition-colors text-lg" data-id="element-110">
            Pay Bill
          </a>
          <a href="#reed-city-registration" className="bg-[#002868] text-white font-bold px-8 py-4 rounded hover:bg-[#001f4d] transition-colors text-lg" data-id="element-111">
            Reed City Customer Registration
          </a>
        </div>
      </div>
    </section>;
}